// extracted by mini-css-extract-plugin
export var loadingSpinner = "_46-1";
export var standaloneTable = "_46-0";